import { notification } from 'antd'
import notifSound from '../../../../assets/audio/notification.mp3'

notification.config({
    placement: 'bottomRight',
    bottom: 50,
    duration: 20,
    maxCount: 3
});

const playNotifySound = () => {
  const audio = new Audio(notifSound);
  audio.play().catch(() => {
    console.warn("Sound playback blocked by browser (autoplay policy).");
  });
};

export const NotifySuccess = (message, description) => {
    playNotifySound()
    notification.success({
        message,
        description,
        placement: `bottomRight`,
})}

export const NotifyInfo = (message, description) =>  {
    playNotifySound()
    notification.info({
        message,
        description,
        placement: `bottomRight`,
})}

export const NotifyWarn = (message, description) =>  {
    playNotifySound()
    notification.warning({
        message,
        description,
        placement: `bottomRight`,
})}